import { useState, useEffect } from "react";

export const getRandomNumber = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const MOBILE_BREAKPOINT = 900; // You can adjust this value based on your theme

export const isMobileDevice = () => {
  return window.innerWidth < MOBILE_BREAKPOINT;
};

export const useMobileCheck = () => {
  const [isMobile, setIsMobile] = useState(isMobileDevice());

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(isMobileDevice());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile;
};

export const X_factor_getColor = (score) => {
  if (score <= 65) return "#EF426F";
  if (score >= 66 && score <= 76) return "#F2853C";
  if (score >= 77 && score <= 86) return "#F7DC62";
  if (score >= 87 && score <= 94) return "#54CE3C";
  if (score >= 95) return "#368911";
  return "#000";
};
export const X_factor_getCollegeColor = (score) => {
  if (score < 105) return "#EF426F"; // Developmental (under 105)
  if (score >= 105 && score <= 114) return "#F2853C"; // Role Player (105-114)
  if (score >= 115 && score <= 129) return "#F7DC62"; // Rotational (115-129)
  if (score >= 130 && score <= 144) return "#b280ff"; // Starter (130-144)
  if (score >= 145) return "#54CE3C"; // Impact (145+)
  return "#000";
};
export const Leagues_getColor = (name) => {
  if (name === "Juco") return "#EF426F";
  if (name === "DII/III") return "#F2853C";
  if (name === "DI") return "#F7DC62";
  if (name === "High Major") return "#54CE3C";
  if (name === "NBA") return "#368911";
  if (name === "HS") return "#000";
  return "#000";
};
export const sim_player_wording = (score) => {
  if (score <= 70) return { color: "#F2853C", wording: "Weak Match" };
  if (score >= 71 && score <= 80)
    return { color: "#54CE3C", wording: "Good Match" };
  if (score >= 81) return { color: "#368911", wording: "Strong Match" };
  return { color: "#000", wording: "-" };
};

export const getRandomProfileImage = () => {
  const images = [
    "https://d3mvy6uwazuxyu.cloudfront.net/back-b-3.png",
    "https://d3mvy6uwazuxyu.cloudfront.net/back-b-4.png",
  ];
  return images[Math.floor(Math.random() * images.length)];
};
export const analysisDescription = (score) => {
  // Convert string to number and round to nearest integer
  const numScore = Math.round(Number(score));

  if (numScore < 50) {
    return { level: "Below Next Level", color: "#fff", label: "hs" };
  } else if (numScore >= 50 && numScore <= 65) {
    return { level: "Juco Level", color: "#EF426F", label: "juco" };
  } else if (numScore >= 66 && numScore <= 76) {
    return {
      level: "Div II / Div III Level",
      color: "#F2853C",
      label: "diidiii",
    };
  } else if (numScore >= 77 && numScore <= 86) {
    return { level: "Div I Level", color: "#F7DC62", label: "di" };
  } else if (numScore >= 87 && numScore <= 94) {
    return { level: "High Major Level", color: "#54CE3C", label: "high_major" };
  } else if (numScore >= 95) {
    return { level: "NBA Level", color: "#368911", label: "nba" };
  }
};
export const chartLabel = (chartType) => {
  if (chartType === "ball_handling") return "ball handling";
  if (chartType === "shooting") return "shooting";
  if (chartType === "defense") return "defense";
  if (chartType === "playmaking") return "playmaking";
  if (chartType === "rebounding") return "rebounding";
  if (chartType === "scoring") return "scoring";
  return "performance";
};
export const DEFAULT_XFACTOR_LABEL = "20";
export const MIN_MINUTES_FOR_XFACTOR = 90;

export const hasLoggedEnoughMinutes = (games, minutesPerGame) => {
  if (!games || !minutesPerGame) return false;
  return games * minutesPerGame >= MIN_MINUTES_FOR_XFACTOR;
};
